import React, { useEffect } from 'react'
import { logout } from '../../libs/lib';
import { useLocation } from 'react-router-dom';

function Logout() {
  const location = useLocation();
  const { pathname } = location;

  useEffect(()=>{
    logout();
  }, [pathname]);

  return (
    <div>登出</div>
  )
}

export default Logout